import moment from 'moment';
import { postResumeActivatePackage, postResumeUnlock } from '../../../services/Api';

const Ticket = ({ onClose, wallets = [], onCharge, resumeSeq }) => {
    const handleUse = (item) => {
        if (item?.walletType !== 'COUNT') {
            handleActivatePackage(item);
            return;
        }

        if (!window.confirm(`[이력서 일반 열람권]을 사용하여 이력서를 열람하시겠습니까?`)) return;

        postResumeUnlock({ resumeSeq, productCode: item?.productCode })
            .then(({ data }) => {
                if (data?.success) {
                    window.alert('이력서 열람이 완료되었습니다.');
                    window.location.reload();
                } else {
                    window.alert('열람권 사용에 실패했습니다.');
                }
            })
            .catch((error) => console.log(error));
    };

    const getPeriodDays = (item) => {
        const fromName = String(item?.productName || '').match(/(\d+)\s*일/);
        if (fromName) return fromName[1];
        const fromCode = String(item?.productCode || '').match(/(\d+)/);
        return fromCode ? fromCode[1] : '';
    };

    const handleActivatePackage = (item) => {
        const days = getPeriodDays(item);
        const message = days
            ? `현 시점부터 이력서 자유 열람을 시작하시겠습니까?\n한번 사용을 시작하시면 기간 중지와 환불이 불가합니다.\n기간: ${days}일`
            : '현 시점부터 이력서 자유 열람을 시작하시겠습니까?\n한번 사용을 시작하시면 기간 중지와 환불이 불가합니다.';
        if (!window.confirm(message)) return;

        postResumeActivatePackage(item?.orderNo)
            .then(({ data }) => {
                const result = typeof data === 'string' ? data : data?.data || data?.result;
                if (result === 'SUCCESS') {
                    window.alert('이력서 자유 열람이 시작되었습니다.');
                    window.location.reload();
                } else {
                    window.alert(data?.message || '열람권 사용에 실패했습니다.');
                }
            })
            .catch((error) => console.log(error));
    };

    return (
        <div className="rsm-ticket-popup active" role="dialog" aria-modal="true" aria-labelledby="ticketPopupTitle">
            <div className="rsm-ticket-popup__container">
                <div className="rsm-ticket-popup__header">
                    <h2 id="ticketPopupTitle">이력서 열람권 내역</h2>
                    <button
                        type="button"
                        className="rsm-ticket-popup__close"
                        aria-label="닫기"
                        onClick={onClose}
                    />
                </div>
                <div className="rsm-ticket-popup__body">
                    <table className="rsm-ticket-popup__table">
                        <thead>
                            <tr>
                                <th>만료예정일</th>
                                <th>상품명</th>
                                <th>잔여수량</th>
                                <th>사용</th>
                            </tr>
                        </thead>
                        <tbody>
                            {wallets && wallets.length > 0 ? (
                                wallets.map((item, index) => {
                                    const isCount = item?.walletType === 'COUNT';
                                    return (
                                        <tr key={item?.walletSeq || index}>
                                            <td>{item?.validTo ? moment(item.validTo).format('YYYY-MM-DD') : ''}</td>
                                            <td>{item?.productName}</td>
                                            <td className="is-blue">{isCount ? item?.remainingCount : ''}</td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className={`rsm-ticket-popup__use-btn ${isCount ? '' : 'is-red'}`}
                                                    onClick={() => handleUse(item)}
                                                >
                                                    사용하기
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={4}>데이터없습니다</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
                <div className="rsm-ticket-popup__footer">
                    <button type="button" className="rsm-ticket-popup__charge-btn" onClick={onCharge}>
                        충전하기
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Ticket;
